<section>
  <h3>Desculpe, não encontramos nada próximo à você</h3>
  <ng-lottie width="20vh" height="20vh" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
</section>
